/* eslint-disable no-console */
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { ErplyAttributes } from 'utils';
import * as api from 'services/ErplyAPI/sales';
import { addError } from 'actions/Error';
import { RootState } from 'reducers';

type SaveSalesDocumentPayload = {
  [key: string]: any;
};

export function saveAttributesToSale({
  temporaryUUID,
  lastSaleDocument,
  reduxCart,
}) {
  return async function action(
    dispatch: ThunkDispatch<RootState, unknown, Action>,
  ) {
    let request: SaveSalesDocumentPayload = {
      id: lastSaleDocument.invoiceID,
      temporaryUUID,
    };

    const allAttrs = new ErplyAttributes({});

    reduxCart.forEach((order, i) => {
      // region Attaching row attributes to the sale
      const rowAttrs = new ErplyAttributes(order.attributes);
      rowAttrs.asArray.forEach(attr => {
        allAttrs.set(
          `row-attribute-${lastSaleDocument.rows[i].stableRowID}-${attr.attributeName}`,
          attr.attributeValue,
        );
      });
      if (allAttrs.asArray.length > 0) {
        request = {
          ...request,
          ...allAttrs.asFlatArray,
        };
      }
      // endregion
    });
    // Send out the request only if there's anything to save. Initial request has just 2 keys, thus the check
    if (Object.keys(request).length > 2) {
      // region Save the updates onto the sale
      try {
        await api.saveSalesDocument(request);
      } catch (e) {
        dispatch(
          addError(
            'Failed to save attribute and parent row ID information onto the sale',
          ),
        );
        console.error(
          'Failed to save attribute and parent row ID information onto the sale: ',
          lastSaleDocument,
          '. Attributes: ',
          allAttrs.asFlatArray,
        );
      }
      // endregion
    }
  };
}
